import React, { Component } from "react";
import { NotificationManager } from "react-notifications";
import { GetUserLogin } from "../../components/services";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      phone: "",
      verificationCode: "",
      password: "",
      step: 1,
      showChangePhone: false,
    };
  }

  componentDidMount() {
    this.setState({
      step: 1,
    });
  }

  handleChange = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const {
      phone,
      verificationCode,
      password,
      step,
    } = this.state;

    // STEP 1 - SEND OTP
    if (step === 1) {
      if (!phone) {
        NotificationManager.error(
          "Please enter your phone number",
          "Error"
        );
        return;
      }

      try {
        const response =
          await GetUserLogin.sendResetPasswordSms(phone);

        if (response && response.success) {
          NotificationManager.success(
            "OTP sent to your phone",
            "Success"
          );

          this.setState({
            step: 2,
            verificationCode: "",
          });
        } else {
          NotificationManager.error(
            "Error sending OTP",
            "Error"
          );
        }
      } catch (error) {
        console.log(error);

        NotificationManager.error(
          "Error sending OTP",
          "Error"
        );
      }
    }

    // STEP 2 - VERIFY OTP
    else if (step === 2) {
      if (!verificationCode) {
        NotificationManager.error(
          "Please enter the OTP",
          "Error"
        );
        return;
      }

      try {
        const response =
          await GetUserLogin.verifyOtp(
            phone,
            verificationCode
          );

        if (response && response.success) {
          NotificationManager.success(
            "OTP verified",
            "Success"
          );

          this.setState({
            step: 3,
          });
        } else {
          NotificationManager.error(
            "Invalid OTP",
            "Error"
          );
        }
      } catch (error) {
        console.log(error);

        NotificationManager.error(
          "Error verifying OTP",
          "Error"
        );
      }
    }

    // STEP 3 - RESET PASSWORD
    else if (step === 3) {
      if (!password) {
        NotificationManager.error(
          "Please enter a new password",
          "Error"
        );
        return;
      }

      if (password.length < 6) {
        NotificationManager.error(
          "Password must be at least 6 characters",
          "Error"
        );
        return;
      }

      try {
        const response =
          await GetUserLogin.resetPassword(
            phone,
            password
          );

        if (response && response.success) {
          NotificationManager.success(
            "Password reset successfully",
            "Success"
          );

          // Clear forgot password state
          this.setState({
            phone: "",
            verificationCode: "",
            password: "",
            step: 1,
            showChangePhone: false,
          });

          // IMPORTANT:
          // Tell parent Login component to show Login tab
          if (this.props.onResetSuccess) {
            this.props.onResetSuccess();
          }
        } else {
          NotificationManager.error(
            "Error resetting password",
            "Error"
          );
        }
      } catch (error) {
        console.log(error);

        NotificationManager.error(
          "Error resetting password",
          "Error"
        );
      }
    }
  };

  handleResendOtp = async () => {
    const { phone } = this.state;

    if (!phone) {
      NotificationManager.error(
        "Please enter your phone number",
        "Error"
      );
      return;
    }

    try {
      const response =
        await GetUserLogin.sendResetPasswordSms(phone);

      if (response && response.success) {
        NotificationManager.success(
          "OTP resent to your phone",
          "Success"
        );

        this.setState({
          verificationCode: "",
        });
      } else {
        NotificationManager.error(
          "Error resending OTP",
          "Error"
        );
      }
    } catch (error) {
      console.log(error);

      NotificationManager.error(
        "Error resending OTP",
        "Error"
      );
    }
  };

  handlePhoneChange = () => {
    this.setState({
      step: 1,
      showChangePhone: false,
      verificationCode: "",
      password: "",
    });
  };

  handleBackToLogin = () => {
    this.setState({
      phone: "",
      verificationCode: "",
      password: "",
      step: 1,
      showChangePhone: false,
    });

    if (this.props.onBackToLogin) {
      this.props.onBackToLogin();
    }
  };

  render() {
    const {
      phone,
      verificationCode,
      password,
      step,
      showChangePhone,
    } = this.state;

    const containerStyle = {
      padding: "10px 5px 5px 5px",
    };

    const titleStyle = {
      textAlign: "center",
      marginBottom: "25px",
      fontSize: "24px",
      fontWeight: "600",
      color: "#222",
    };

    const subtitleStyle = {
      textAlign: "center",
      color: "#777",
      fontSize: "14px",
      marginBottom: "25px",
      lineHeight: "1.5",
    };

    const fieldStyle = {
      marginBottom: "20px",
    };

    const labelStyle = {
      display: "block",
      marginBottom: "8px",
      fontWeight: "500",
      color: "#333",
      fontSize: "14px",
    };

    const inputStyle = {
      width: "100%",
      height: "46px",
      padding: "10px 14px",
      border: "1px solid #ddd",
      borderRadius: "5px",
      fontSize: "14px",
      outline: "none",
      boxSizing: "border-box",
    };

    const buttonStyle = {
      width: "100%",
      height: "46px",
      borderRadius: "5px",
      marginTop: "5px",
      fontWeight: "500",
    };

    const linkButtonStyle = {
      border: "none",
      background: "transparent",
      padding: "5px 0",
      color: "#333",
      cursor: "pointer",
      fontSize: "14px",
      textDecoration: "none",
    };

    return (
      <div style={containerStyle}>

        <h2 style={titleStyle}>
          Forgot Password
        </h2>

        <p style={subtitleStyle}>
          {step === 1 &&
            "Enter your registered phone number to receive an OTP."}

          {step === 2 &&
            "Enter the OTP sent to your registered phone number."}

          {step === 3 &&
            "Create a new password for your account."}
        </p>

        <form onSubmit={this.handleSubmit} noValidate>

          {/* STEP 1 */}
          {step === 1 && (
            <fieldset
              className="form-group"
              style={{
                border: "none",
                padding: 0,
                margin: 0,
              }}
            >

              <div style={fieldStyle}>
                <label style={labelStyle}>
                  Enter Phone Number
                </label>

                <input
                  type="tel"
                  className="form-control"
                  name="phone"
                  value={phone}
                  onChange={this.handleChange}
                  placeholder="Enter 10-digit mobile number"
                  maxLength="10"
                  required
                  style={inputStyle}
                />
              </div>

              <button
                type="submit"
                className="btn btn-lg btn-secondary btn-block"
                style={buttonStyle}
              >
                Send OTP
              </button>

            </fieldset>
          )}

          {/* STEP 2 */}
          {step === 2 && (
            <fieldset
              className="form-group"
              style={{
                border: "none",
                padding: 0,
                margin: 0,
              }}
            >

              <div style={fieldStyle}>

                <label style={labelStyle}>
                  Phone Number
                </label>

                {!showChangePhone ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      background: "#f7f7f7",
                      border: "1px solid #e5e5e5",
                      borderRadius: "5px",
                      padding: "10px 14px",
                      minHeight: "46px",
                      boxSizing: "border-box",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "14px",
                        color: "#444",
                      }}
                    >
                      {phone}
                    </span>

                    <button
                      type="button"
                      onClick={() =>
                        this.setState({
                          showChangePhone: true,
                        })
                      }
                      style={{
                        border: "none",
                        background: "transparent",
                        color: "#333",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: "500",
                      }}
                    >
                      Re-enter Phone
                    </button>
                  </div>
                ) : (
                  <input
                    type="tel"
                    className="form-control"
                    name="phone"
                    value={phone}
                    onChange={this.handleChange}
                    placeholder="Enter 10-digit mobile number"
                    maxLength="10"
                    required
                    style={inputStyle}
                  />
                )}

              </div>

              <div style={fieldStyle}>
                <label style={labelStyle}>
                  Enter OTP
                </label>

                <input
                  type="text"
                  className="form-control"
                  name="verificationCode"
                  value={verificationCode}
                  onChange={this.handleChange}
                  placeholder="Enter 6-digit OTP"
                  maxLength="6"
                  required
                  style={inputStyle}
                />
              </div>

              <button
                type="submit"
                className="btn btn-lg btn-secondary btn-block"
                style={buttonStyle}
              >
                Verify OTP
              </button>

              <div
                style={{
                  textAlign: "center",
                  marginTop: "15px",
                }}
              >
                <button
                  type="button"
                  style={linkButtonStyle}
                  onClick={this.handleResendOtp}
                >
                  Resend OTP
                </button>
              </div>

              {showChangePhone && (
                <div
                  style={{
                    textAlign: "center",
                    marginTop: "5px",
                  }}
                >
                  <button
                    type="button"
                    style={linkButtonStyle}
                    onClick={this.handlePhoneChange}
                  >
                    Update Phone
                  </button>
                </div>
              )}

            </fieldset>
          )}

          {/* STEP 3 */}
          {step === 3 && (
            <fieldset
              className="form-group"
              style={{
                border: "none",
                padding: 0,
                margin: 0,
              }}
            >

              <div style={fieldStyle}>
                <label style={labelStyle}>
                  New Password
                </label>

                <input
                  type="password"
                  className="form-control"
                  name="password"
                  value={password}
                  onChange={this.handleChange}
                  placeholder="Enter new password"
                  required
                  style={inputStyle}
                />

                <small
                  style={{
                    display: "block",
                    marginTop: "7px",
                    color: "#777",
                    fontSize: "12px",
                  }}
                >
                  Password must contain at least 6 characters.
                </small>
              </div>

              <button
                type="submit"
                className="btn btn-lg btn-secondary btn-block"
                style={buttonStyle}
              >
                Reset Password
              </button>

            </fieldset>
          )}

        </form>

        {/* BACK TO LOGIN */}
        <div
          style={{
            textAlign: "center",
            marginTop: "25px",
            paddingTop: "18px",
            borderTop: "1px solid #eee",
          }}
        >
          <button
            type="button"
            onClick={this.handleBackToLogin}
            style={{
              border: "none",
              background: "transparent",
              color: "#000000",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              padding: "5px 10px",
            }}
          >
            ← Back to Login
          </button>
        </div>

      </div>
    );
  }
}

export default ForgotPassword;